/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Highlight_Color_Open_PickerInputs */

const en_settings_highlight_color_open_picker = /** @type {(inputs: Settings_Highlight_Color_Open_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose highlight color`)
};

const es_settings_highlight_color_open_picker = /** @type {(inputs: Settings_Highlight_Color_Open_PickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir color de resaltado`)
};

/**
* | output |
* | --- |
* | "Choose highlight color" |
*
* @param {Settings_Highlight_Color_Open_PickerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_highlight_color_open_picker = /** @type {((inputs?: Settings_Highlight_Color_Open_PickerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Highlight_Color_Open_PickerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_highlight_color_open_picker(inputs)
	return en_settings_highlight_color_open_picker(inputs)
});